export default __webpack_public_path__ + "static/media/user.ff788981.png";